module.exports = __webpack_public_path__ + "images/cybernetics.png?v=6f0ea39c7e468ae63c6fe0551b22f71f";